import { allowedGeneralSettings } from './general-settings.js';

const leaf = (tab, label, section) => ({ id: section ? `${tab}:${section}` : tab, tab, label, ...(section ? { section } : {}) });

export function settingsNavigation(auth) {
  const general = allowedGeneralSettings(auth);
  const groups = [
    { id: 'personal', label: 'Личное', items: [leaf('profile', 'Профиль'), leaf('security', 'Безопасность'), leaf('notifications', 'Уведомления')] },
    { id: 'organization', label: 'Организация', items: [
      ...(auth.isAdmin ? [leaf('organization', 'Подразделения'), leaf('permissions', 'Должности')] : []),
      ...(auth.hasPermission('workshops.manage') ? [leaf('workshops', 'Цеха')] : [])
    ] },
    { id: 'integrations', label: 'Интеграции', items: [
      ...(auth.isAdmin ? [leaf('banks', 'Банки')] : []),
      ...general.filter(item => item.id === 'inventory').map(item => leaf('general', item.label, item.id))
    ] },
    { id: 'assistants', label: 'Ассистенты', items: auth.isAdmin ? [leaf('assistant', 'НУР-Ассистент'), leaf('legal-bot', 'Нейро-Юрист'), leaf('accounting-bot', 'НУР-Бухгалтер')] : [] },
    { id: 'platform', label: 'Платформа', items: general.filter(item => item.id !== 'inventory').map(item => leaf('general', item.label, item.id)) }
  ].filter(group => group.items.length);
  return { groups, items: groups.flatMap(group => group.items), defaultGeneral: general[0]?.id || '' };
}

const searchTerms = {
  profile: 'имя фамилия телефон почта фото аватар дата рождения',
  security: 'пароль вход сессии', notifications: 'push пуш звук сообщения чаты',
  organization: 'рестораны отделы команда адрес', permissions: 'права доступ роли',
  workshops: 'блюда кухня бар', banks: 'счета банк привязка',
  'general:inventory': 'storehouse sh склад товары интеграция',
  'general:dashboard': 'обзор блоки главная', 'general:analytics': 'метрики выручка показатели',
  'general:temperature': 'датчики оборудование температура', 'general:reviews': 'источники отзывы',
  'general:audit': 'проверки нарушения аудит'
};
const searchable = value => String(value || '').toLocaleLowerCase('ru').replaceAll('ё', 'е').trim();
export function filterSettingsGroups(navigation, query = '') {
  const words = searchable(query).split(/\s+/).filter(Boolean);
  if (!words.length) return navigation.groups;
  return navigation.groups.map(group => ({ ...group, items: group.items.filter(item => {
    const text = searchable(`${group.label} ${item.label} ${searchTerms[item.id] || ''}`);
    return words.every(word => text.includes(word));
  }) })).filter(group => group.items.length);
}

export function settingsSelection(navigation, query = {}) {
  const requestedTab = String(query.tab || 'profile');
  const tab = navigation.items.some(item => item.tab === requestedTab) ? requestedTab : 'profile';
  const section = tab === 'general' ? String(query.section || navigation.defaultGeneral) : '';
  const item = navigation.items.find(item => item.tab === tab && (tab !== 'general' || item.section === section));
  // Invalid General sections keep the existing access-error panel and URL.
  const group = navigation.groups.find(group => group.items.some(leaf => leaf.id === item?.id))
    || navigation.groups.find(group => group.id === 'platform') || navigation.groups[0];
  return { tab, section, item, group };
}

export function settingsLocation(item, query = {}) {
  const next = { ...query };
  if (item.tab === 'profile') delete next.tab;
  else next.tab = item.tab;
  if (item.section) next.section = item.section;
  else delete next.section;
  return { path: '/settings', query: next };
}

export function settingsDirection(to = {}, from = {}) {
  const navigation = settingsNavigation({ isAdmin: true, hasPermission: () => true });
  const index = query => {
    const selected = settingsSelection(navigation, query);
    return navigation.items.findIndex(item => item.id === (selected.item || selected.group.items[0]).id);
  };
  return index(to) < index(from) ? -1 : 1;
}
